import { BusinessModel } from '@/views/standardstore/pages/tasklist/ts-config';
/** Locxx 拓店任务模板码。 */
export var LOCXX_TASK_TEMPLATE_CODE = BusinessModel.Locxx;
/** Locxx 拓店计划透传的任务列表场景。 */
export var LOCXX_EXPANSION_TASK_LIST_SCENE = 'locxxExpansionTaskList';
function toOptionalNumber(value) {
    if (value === '' || value === null || value === undefined)
        return undefined;
    var numberValue = Number(value);
    return Number.isFinite(numberValue) ? numberValue : undefined;
}
/** 按直拓任务创建接口整理 Locxx 专属字段，预算单位固定为万元。 */
export function buildLocxxDirectCreateParams(values) {
    var _a, _b;
    var params = {
        modelClusterId: toOptionalNumber(values.modelClusterId),
        name: values.name,
        totalBudget: toOptionalNumber(values.totalBudget),
        expectDropInDate: values.expectDropInDate,
    };
    var optionalNumbers = ['marketingPurpose', 'areaRequirementMin', 'areaRequirementMax', 'floorHeight', 'minFlowBottomLine', 'activityPeriodCount', 'activityPeriodUnit', 'followingStatus'];
    optionalNumbers.forEach(function (key) {
        var value = toOptionalNumber(values[key]);
        if (value !== undefined)
            params[key] = value;
    });
    if ((_a = values.promotionDate) === null || _a === void 0 ? void 0 : _a.start)
        params.promotionDateStart = values.promotionDate.start;
    if ((_b = values.promotionDate) === null || _b === void 0 ? void 0 : _b.end)
        params.promotionDateEnd = values.promotionDate.end;
    if (Array.isArray(values.targetAddress)) {
        ['targetProvinceId', 'targetCityId', 'targetDistrictId'].forEach(function (key, index) {
            if (values.targetAddress[index])
                params[key] = toOptionalNumber(values.targetAddress[index]);
        });
    }
    if (Array.isArray(values.assignAccountIds) && values.assignAccountIds.length)
        params.assignAccountIds = values.assignAccountIds;
    if (values.managerId)
        params.managerId = toOptionalNumber(values.managerId);
    return params;
}
/** 按 YApi 88990 仅提交商圈拓店模板允许更新的字段。 */
export function buildLocxxDirectUpdateParams(values, id) {
    return {
        id: id,
        name: values.name,
        expectDropInDate: values.expectDropInDate,
        followingStatus: toOptionalNumber(values.followingStatus),
        areaRequirementMin: toOptionalNumber(values.areaRequirementMin),
        areaRequirementMax: toOptionalNumber(values.areaRequirementMax),
        activityPeriodCount: toOptionalNumber(values.activityPeriodCount),
        activityPeriodUnit: toOptionalNumber(values.activityPeriodUnit),
    };
}
/** Locxx 营销目的展示口径。 */
export function getLocxxMarketingPurposeName(value) {
    var marketingPurposeMap = { 6: '品牌宣传', 7: '获客', 8: '售卖' };
    return marketingPurposeMap[Number(value)] || '';
}
/** 场地预算单位为万元，详情统一保留两位小数。 */
export function formatLocxxBudget(value) {
    if (value === '' || value === null || value === undefined)
        return '';
    var budget = Number(value);
    return Number.isFinite(budget) ? budget.toFixed(2) + "\u4E07\u5143" : '';
}
/** Locxx 任务名称统一由意向商圈城市和名称拼接。 */
export function buildLocxxTaskName(cityName, modelClusterName) {
    return cityName && modelClusterName ? cityName + "_" + modelClusterName + "_\u62D3\u5E97\u4EFB\u52A1" : '';
}
/** Locxx 列表开发人员展示使用任务接口返回的 manager。 */
export function getLocxxDeveloperName(value) {
    if (value === void 0) { value = {}; }
    return value.manager || '';
}
/** 生成意向商圈选址地图详情路径。 */
export function buildLocxxClusterDetailPath(taskId, clusterId) {
    var task = toOptionalNumber(taskId);
    var cluster = toOptionalNumber(clusterId);
    return task && cluster ? "/iterate/siteselectionmapdetail?areaId=" + cluster + "&taskId=" + task : '';
}
/** 兼容页面既有 id 参数与消息透传 taskId 参数，只接受正整数任务 ID。 */
export function getValidLocxxTaskId(query) {
    if (query === void 0) { query = {}; }
    var rawId = query.taskId || query.id;
    var taskId = Number(rawId);
    return Number.isInteger(taskId) && taskId > 0 ? taskId : null;
}
/** 消息透传 template 用于识别 Locxx 模板，编辑权限由任务 ID 单独校验。 */
export function getLocxxTaskTemplateCode(query) {
    if (query === void 0) { query = {}; }
    return query.template === LOCXX_TASK_TEMPLATE_CODE
        ? LOCXX_TASK_TEMPLATE_CODE
        : '';
}
/** Locxx 列表入口未指定 tab 时，默认展示“我的任务”。 */
export function shouldUseLocxxTaskListDefaultTab(query, isLocxxTaskTemplate) {
    if (query === void 0) { query = {}; }
    if (isLocxxTaskTemplate === void 0) { isLocxxTaskTemplate = false; }
    var hasExplicitTab = Object.prototype.hasOwnProperty.call(query, 'tab');
    return !hasExplicitTab && (query.scene === LOCXX_EXPANSION_TASK_LIST_SCENE || isLocxxTaskTemplate);
}
/** Locxx 编辑入口需要有效任务 ID；直接创建场景不依赖此判断。 */
export function canOpenLocxxTaskEditor(query) {
    if (query === void 0) { query = {}; }
    return !!getValidLocxxTaskId(query);
}
